<template>
  <Layout>
    <PageHeader :title="title" :subTitle="subTitle">
      <template #afterTitle>
        <div class="d-flex align-items-center gap-3">
          <McButtonBack href="/qcdevice/ibeacon" />
        </div>
      </template>
    </PageHeader>
    
    <McWizard
      withNumber
      class="mc-wizard mb-4"
      :activeKey="activeWizardImport"
      :items="wizardItems"
    />

    <router-view />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButtonBack from '@/components/McButtonBack'
import McWizard from '@/components/McWizard'

export default {
  page: {
    title: 'Import IBEACON',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McWizard,
  },
  data() {
    return {
      activeWizardImport: 'upload-content',
    }
  },
  computed: {
    title() {
      return this.$t('qcdevice.import.uploadDocument')
    },
    subTitle() {
      return this.$t('qcdevice.import.uploadDescriptionIbeacon')
    },
    wizardItems() {
      return [
        { key: 'upload-content', label: this.$t('global.upload') },
        { key: 'process-content', label: this.$t('workOrder.table.process') },
        { key: 'result-content', label: this.$t('global.result') },
      ]
    },
  },
  watch: {
    '$route.name': {
      handler(value) {
        this.handleActiveWizard(value)
      },
      immediate: true,
    },
  },
  methods: {
    handleActiveWizard(routeName) {
      if (routeName === 'IBEACON Import') {
        this.activeWizardImport = 'upload-content'
        return
      }

      if (routeName === 'IBEACON Import Detail') {
        this.activeWizardImport = 'process-content'
        return
      }

      this.activeWizardImport = 'result-content'
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.mc-wizard) {
  display: inline-block;
  width: 100%;
}
</style>
